// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0fbcc99f","839":"69fa8568"}[chunkId] + ".chunk.js";
};